import React from "react";
import { useNavigate } from "react-router-dom";
import { conversationList } from "../../Services/Redux/Reducers/chatSlice";
import { loader } from "../../Services/Redux/Reducers/commonSlice";
import { useDispatch } from "react-redux";

function StaticFooter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const staticNewChat = () => {
    dispatch(conversationList([]));
    dispatch(loader(false))
    navigate("/chat");
  };

  return (
    <div className="static-footer d-flex flex-column align-items-center carousel-polar-div">
      <div className="footer-head">Ready to Ask Ralph?</div>
      <div className="d-flex flex-column align-items-center">
        <button
          name="staticNewChatButton"
          className="btn btn-custom-blue rounded-circle static-chat-btn"
          onClick={staticNewChat}
        >
          <img
            src="./static/assets/StaticLandingPageImages/static_newchat.svg"
            height="24px"
            width="24px"
            className="static-chat-icon"
            alt="new_chat"
          />
        </button>
        <span className="static-label">START CHAT</span>
      </div>
    </div>
  );
}

export default StaticFooter;
